<template>
<div 
  @click="onClick"  
  style="border:1px solid #ddd;border-radius:10px;padding:5px 10px;background: #fff;"
>
  <v-layout row wrap>
    <v-flex xs10 style="text-align:left;">
      <p class="formElementLabel"><v-icon small>restaurant</v-icon> {{label_text}}</p>
      <p style="font-weight: bold;" class="primary--text">{{name}}</p>
      <p style="white-space: nowrap;overflow-x: auto;">{{address}}</p>
    </v-flex>
    <v-flex xs2 style="text-align:center;padding-top:10px;">
      <v-btn icon small class="primary--text"><v-icon>launch</v-icon></v-btn>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
export default {
  name: 'ShopCardMin',
  data () {
    return {
      label_text: '飲食店'
    }
  },
  computed: {
    address () {
      if (this.shop.form) {
        if (this.shop.form.address.length > 10) {
          return this.shop.form.address
        }
      }
      if (this.shop.basic) {
        return this.shop.basic.address
      }
      if (this.shop.address) {
        return this.shop.address
      }
      return ''
    },
    name () {
      if (this.shop.basic) {
        return this.shop.basic.name
      } else {
        if (this.shop.name) {
          return this.shop.name
        }
      }
      return ''
    }
  },
  props: {
    shop: Object,
    label: String
  },
  mounted () {
    if (this.label) {
      this.label_text = this.label
    }
  },
  methods: {
    onClick () {
      this.$emit('onClick')
    }
  },
  components: {
  }
}
</script>

<style scoped>
p {
  padding: 0;
  margin-bottom: 2px;
}
.formElementLabel {
  text-align: left;
  color:#888;
}
</style>